/*eslint no-implicit-globals: ["error", {"lexicalBindings": true}]*/
import React, { useEffect, useState } from 'react'
import { buttonToTop } from 'constants/images'
import 'assets/scss/Wrapper.scss'
import { useSelector, shallowEqual } from 'react-redux'
import { useLocation, useNavigationType } from 'react-router-dom'

const Wrapper = ({ children }) => {
  const count = useSelector((state) => state.cart.count, shallowEqual)
  const mealDetails = useSelector((state) => state.cart.xpMealDetails, shallowEqual)
  const location = useLocation()
  const navType = useNavigationType()
  const [visible, setVisible] = useState(false)
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop
    if (scrolled > 1000) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }

  useEffect(() => {
    if (navType !== 'POP') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }, [location])

  useEffect(() => {
    localStorage.setItem('cart_count', count || 0)
    if (count > 0) {
      localStorage.setItem('cart_first_item', JSON.stringify(mealDetails))
    } else {
      localStorage.removeItem('cart_first_item')
    }
  }, [count])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  window.addEventListener('scroll', toggleVisible)

  return (
    <div>
      {children}
      {visible && <img src={buttonToTop} onClick={scrollToTop} alt="scroll up" className="float my-float" />}
    </div>
  )
}
export default Wrapper
